import { isIOS } from '@fluentui/react/lib/Utilities';

type IsIE = () => boolean;
export const isIE: IsIE = () => /MSIE|Trident\//.test(window.navigator.userAgent);

export { isIOS };
